import { useSelector } from "react-redux";

import VendorWalletPanel from "./VendorWalletPanel";
import "./vendorWallet.scss";

/**
 * «المحفظة» — the restaurant's own wallet, for `role === "vendor"` users of
 * this dashboard (admin#41).
 *
 * READ-ONLY on purpose. A restaurant can see its balance, why it is closed and
 * every movement, and cannot credit itself or switch the wallet off: the API
 * refuses both, and nothing here offers them.
 *
 * It refreshes on focus and every minute, because orders and refunds move the
 * balance while the tab is in the background.
 */
const MyVendorWallet = () => {
    const adminInfo = useSelector((state) => state.auth.userData);

    return (
        <div className="items vendor-wallet-page">
            <h4 className="vendor-wallet-page__title">المحفظة</h4>
            <p className="vendor-wallet-page__subtitle">
                تُخصم عمولة كل طلب من الرصيد عند إنشاء الطلب، وتُعاد عند إلغائه.
            </p>
            <VendorWalletPanel userId={adminInfo?.id} refreshOnFocus />
        </div>
    );
};

export default MyVendorWallet;
